import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BrainGraphPage } from '@/features/metric-hub/graph/brain/BrainGraphPage';
import { GraphPage } from '@/features/metric-hub/graph/GraphPage';
import { ModePill } from '@/features/metric-hub/graph/ModePill';
import { useTrackSkillOnDwell } from '@/features/metric-hub/onboarding/use-skill-tracker';

function GraphRoute() {
  useTrackSkillOnDwell('open_graph');
  const { mode } = Route.useSearch();
  if (mode === 'brain') return <BrainGraphPage />;
  return (
    <div className="relative">
      <GraphPage />
      {/* Floating mode switch — GraphPage itself stays byte-identical. Desktop
          bottom-center is the only slot free of the lineage overlays (Legend
          top-left, zoom bottom-left, MiniMap bottom-right, DetailPanel
          top-right); mobile gets top-right under the toolbar (the DetailPanel
          owns the mobile bottom edge). */}
      <div className="pointer-events-none absolute inset-x-0 bottom-3 z-10 hidden justify-center sm:flex">
        <ModePill mode="lineage" />
      </div>
      <div className="pointer-events-none absolute right-3 top-16 z-10 flex sm:hidden">
        <ModePill mode="lineage" />
      </div>
    </div>
  );
}

/**
 * Shareable graph view: filters + layout direction + grouping + search live in
 * the URL so a teammate can open the exact same state. All optional — a bare
 * `/metric-hub/graph` renders the default (all kinds, LR, ungrouped).
 * `mode=brain` swaps the lineage canvas for the Brain Graph (semantic galaxy);
 * absent = lineage, so lineage URLs stay clean and survive GraphPage's
 * wholesale search writes.
 */
export const Route = createFileRoute('/_authed/metric-hub/graph')({
  validateSearch: z.object({
    kinds: z.array(z.enum(['semantic_model', 'measure', 'metric'])).optional(),
    dir: z.enum(['LR', 'TB']).optional(),
    group: z.boolean().optional(),
    density: z.enum(['compact', 'cozy']).optional(),
    q: z.string().optional(),
    mode: z.enum(['lineage', 'brain']).optional(),
  }),
  component: GraphRoute,
});
